import React, { Component } from "react";
import getHeaderData from "../../lib/getHeaderData";

export default class Basket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemsCount: this.getItemsCount()
    };
  }
  getItemsCount = () => {
    const staticContext = this.props.staticContext;
    const { initialData } = getHeaderData(staticContext, "basket");
    let basketData = initialData;
    let itemsCount = 0;
    if (basketData && basketData.items && basketData.items.length) {
      itemsCount = basketData.items.length;
    }
    return itemsCount;
  };
  render() {
    const { itemsCount } = this.state;
    return (
      (itemsCount && (
        <div className="visible-xs">
          <a href="/checkout" className="sticky-basket">
            <i className="icon icon-basket" />
            <span>{itemsCount}</span>
          </a>
        </div>
      )) || <noscript />
    );
  }
}
